import React from 'react';

// a list of what the button accepts
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'gradient' | 'default';
}

// initializing the button with its properties
export const Button = ({
                           children,
                           className,
                           variant = 'default',
                           ...props
                       }: ButtonProps) => {
    // this style applies to all buttons
    const baseStyles = 'inline-flex items-center justify-center gap-4 rounded-lg text-sm font-semibold transition-all disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer';
    // styles based on the variant prop
    const variantStyles = {
        default: 'bg-gray-200 text-gray-800 hover:bg-gray-300 h-10 px-4 py-3',
        gradient: 'text-white bg-gradient-to-r from-blue-500 to-orange-400 h-10 px-4 shadow-[0_4px_12px_rgba(0,0,0,0.1)] hover:shadow-[0_8px_16px_rgba(0,0,0,0.15)] hover:opacity-90',
    };

    // combines all the styles together
    const combinedStyles = `${baseStyles} ${variantStyles[variant]} ${className || ''}`;

    return(
        <button className={combinedStyles} {...props}>
            {children}
        </button>
    );
};
